import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class cuentaspagarService {

    /******* QUERIES ******/

    async listar_estados() {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/estado`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async ver(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/ver?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async verPago(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/ver_pago?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

        async dashboardDeuda(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/dashboard-deuda?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async dashboardTotal(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/dashboard-pago-total?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardTotalVencidos(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/dashboard-pago-vencido?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };



    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket50(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/pdf-ticket-50?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };



    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async excelResumen(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/excelResumen?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelDetallado(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/cuentas-pagar/excelDetallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/cuentas-pagar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };



 
}

export default new cuentaspagarService();